<template>
  <div style="text-align: center">
    <div style="width: 90%; text-align: center; margin: 0 auto">
      <p class="title is-2" v-if="width < 1100"> Your certificate is ready! <br><br>  </p> 
      <Button @click="download" id="downloadButton" :style="{ fontSize: width < 1100 ? '20px' : '40px'}"> Download Certificate</Button>
      <br><br>
    </div>
    
    <canvas v-show="width > 1100" id="canvas" style="border: 1px solid grey" @click="download"></canvas>
    <br>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {
  },
  data() {
    return {
      canvas: null,
      width: 1100,
      name: ""
    };
  },
  computed: {
    
  },
  methods: {
    doCanvas() {

    },
    download() {
      var link = document.createElement('a');
      link.href = this.canvas.toDataURL('image/jpeg');
      link.download = this.getUrlParam('name') + ' Certificate.png'
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    },
    getUrlParam: function (str) {
      var url = new URL(window.location.href)
      return url.searchParams.get(str.toLowerCase()) || ''
    },
  },
  mounted() {
    console.log("Mounted")
    this.width = window.innerWidth;
    var canvas = document.getElementById("canvas")
    this.canvas = canvas
    var ctx = canvas.getContext("2d");
    
    console.log(window.innerWidth)
    // var ratio = 850 / 1100
    // var w = Math.min(1100, window.innerWidth * 0.9)
    // canvas.width = w
    // var h = ratio * w
    // canvas.height = h
    // console.log(w, h)
    // canvas.width = 1000 // 1176
    // canvas.height = 707 // 1346


    var background = new Image();
    background.src = "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/legalwise/aus-june-3.jpeg";
    background.crossOrigin="anonymous"
    var img = background
    // Make sure the image is loaded first otherwise nothing will draw.
    background.onload = ()=>
    {
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight
      ctx = canvas.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, 0, 0, img.width,    img.height, 0, 0, canvas.width, canvas.height);
      // ctx.globalCompositeOperation='destination-under';
      // ctx.fillStyle = "#253f8e";
      ctx.font = "bold 180px Arial";

      var name = (this.getUrlParam("contact_first_name") || "").toUpperCase()
      var text = ctx.measureText(name)
      console.log(text, canvas.width / 17)
      ctx.fillText(name, (canvas.width / 17), (canvas.height / 3) - 25);

      var name = (this.getUrlParam("contact_last_name") || "").toUpperCase()
      var text = ctx.measureText(name)
      console.log(text)
      ctx.fillText(name, (canvas.width / 17), (canvas.height / 2) - 250);

      ctx.font = "80px Arial";
      ctx.textAlign = "left"
      // ctx.fillText(this.getUrlParam("event") || "", (canvas.width / 2) + 357, (canvas.height / 2) + 40);
      var s = this.getUrlParam("event") || ""
      console.log("event: " + s)
      var arr = s.split(" ")
      console.log(arr)
      var s1 = arr.slice(0, arr.length / 2).join(" ")
      var s2 = arr.slice(arr.length / 2, arr.length).join(" ")
      if (s.length < 30) { 
        s1 = s
        s2 = ""
      }

      ctx.fillText(s1, (canvas.width / 2) + 357, (canvas.height / 2) + 40);
      ctx.fillText(s2, (canvas.width / 2) + 357, (canvas.height / 2) + 130);
      
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      const formattedToday = dd + '/' + mm + '/' + yyyy;
      ctx.fillText(formattedToday, (canvas.width / 2) + 357, (canvas.height / 2) + 300)

      

      ctx.font = "44px Arial";
      ctx.fillStyle = "white"
      ctx.textAlign = "left"
      var name = (this.getUrlParam("points") || "").toUpperCase()
      var text = ctx.measureText(name)
      console.log(text)
      ctx.fillText(name, (canvas.width / 2) + 815, (canvas.height - 555));

      ctx.fillText(this.getUrlParam("topic1") || "", (canvas.width / 2) + 235, (canvas.height - 485));
      ctx.fillText(this.getUrlParam("topic2") || "", (canvas.width / 2) + 235, (canvas.height - 425));
      ctx.fillText(this.getUrlParam("topic3") || "", (canvas.width / 2) + 235, (canvas.height - 365));
      ctx.fillText(this.getUrlParam("topic4") || "", (canvas.width / 2) + 235, (canvas.height - 305));
    }

  },
};
</script>

<style scoped lang="scss">
  canvas {
    background-size: 100% 100%;
    cursor: pointer;
    max-width: 80vw;
    max-height: 70vh;
  }

  #app {
    text-align: center
  }

  #downloadButton {
    background: #1e6eb0;
    color: white;
    width: auto;
    height: auto;
    padding: 15px 25px;
    border: 1px solid white;
    border-radius: 10px;
    font-size: 24px;
    cursor: pointer;

  }
</style>